"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VenueSearchDemoCombinedRecordDto = exports.VenueSearchDemoRawRecordDto = exports.VenueSearchDemoMappedVenueDto = exports.VenueSearchDemoSourceErrorDto = exports.VenueSearchDemoMatchStatus = exports.VenueSearchDemoSource = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
var VenueSearchDemoSource;
(function (VenueSearchDemoSource) {
  VenueSearchDemoSource["Overture"] = "overture";
  VenueSearchDemoSource["Osm"] = "osm";
  VenueSearchDemoSource["Combined"] = "combined";
})(VenueSearchDemoSource || (exports.VenueSearchDemoSource = VenueSearchDemoSource = {}));
var VenueSearchDemoMatchStatus;
(function (VenueSearchDemoMatchStatus) {
  VenueSearchDemoMatchStatus["Matched"] = "matched";
  VenueSearchDemoMatchStatus["OvertureOnly"] = "overture_only";
  VenueSearchDemoMatchStatus["OsmOnly"] = "osm_only";
})(VenueSearchDemoMatchStatus || (exports.VenueSearchDemoMatchStatus = VenueSearchDemoMatchStatus = {}));
class VenueSearchDemoSourceErrorDto {}
exports.VenueSearchDemoSourceErrorDto = VenueSearchDemoSourceErrorDto;
__decorate([(0, swagger_1.ApiProperty)({
  enum: VenueSearchDemoSource
}), __metadata("design:type", String)], VenueSearchDemoSourceErrorDto.prototype, "source", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueSearchDemoSourceErrorDto.prototype, "message", void 0);
class VenueSearchDemoMappedVenueDto {}
exports.VenueSearchDemoMappedVenueDto = VenueSearchDemoMappedVenueDto;
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Stable UI/provider key, e.g. overture:<gers-id> or osm:node/123'
}), __metadata("design:type", String)], VenueSearchDemoMappedVenueDto.prototype, "providerKey", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Overture GERS id when from Overture (no prefix)'
}), __metadata("design:type", Object)], VenueSearchDemoMappedVenueDto.prototype, "overtureId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'OSM element id when from OSM, e.g. node/123'
}), __metadata("design:type", Object)], VenueSearchDemoMappedVenueDto.prototype, "osmId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueSearchDemoMappedVenueDto.prototype, "name", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.VenueType
}), __metadata("design:type", String)], VenueSearchDemoMappedVenueDto.prototype, "type", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VenueSearchDemoMappedVenueDto.prototype, "latitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VenueSearchDemoMappedVenueDto.prototype, "longitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VenueSearchDemoMappedVenueDto.prototype, "northeastLatitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VenueSearchDemoMappedVenueDto.prototype, "northeastLongitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VenueSearchDemoMappedVenueDto.prototype, "southwestLatitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VenueSearchDemoMappedVenueDto.prototype, "southwestLongitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSearchDemoMappedVenueDto.prototype, "address", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSearchDemoMappedVenueDto.prototype, "postalCode", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSearchDemoMappedVenueDto.prototype, "telephone", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Raw OSM opening_hours string (parser TBD for production)'
}), __metadata("design:type", Object)], VenueSearchDemoMappedVenueDto.prototype, "openingHoursRaw", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  enum: ['osm', 'custom']
}), __metadata("design:type", Object)], VenueSearchDemoMappedVenueDto.prototype, "openingHoursSource", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: [String]
}), __metadata("design:type", Array)], VenueSearchDemoMappedVenueDto.prototype, "dataSources", void 0);
class VenueSearchDemoRawRecordDto {}
exports.VenueSearchDemoRawRecordDto = VenueSearchDemoRawRecordDto;
__decorate([(0, swagger_1.ApiProperty)({
  enum: VenueSearchDemoSource
}), __metadata("design:type", String)], VenueSearchDemoRawRecordDto.prototype, "source", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueSearchDemoRawRecordDto.prototype, "sourceId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], VenueSearchDemoRawRecordDto.prototype, "name", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSearchDemoRawRecordDto.prototype, "latitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSearchDemoRawRecordDto.prototype, "longitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: 'object',
  additionalProperties: true
}), __metadata("design:type", Object)], VenueSearchDemoRawRecordDto.prototype, "raw", void 0);
class VenueSearchDemoCombinedRecordDto {}
exports.VenueSearchDemoCombinedRecordDto = VenueSearchDemoCombinedRecordDto;
__decorate([(0, swagger_1.ApiProperty)({
  enum: VenueSearchDemoMatchStatus
}), __metadata("design:type", String)], VenueSearchDemoCombinedRecordDto.prototype, "matchStatus", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSearchDemoCombinedRecordDto.prototype, "matchDistanceMeters", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueSearchDemoCombinedRecordDto.prototype, "nameSimilarity", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: VenueSearchDemoRawRecordDto,
  nullable: true
}), __metadata("design:type", Object)], VenueSearchDemoCombinedRecordDto.prototype, "overture", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: VenueSearchDemoRawRecordDto,
  nullable: true
}), __metadata("design:type", Object)], VenueSearchDemoCombinedRecordDto.prototype, "osm", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: VenueSearchDemoMappedVenueDto
}), __metadata("design:type", VenueSearchDemoMappedVenueDto)], VenueSearchDemoCombinedRecordDto.prototype, "mapped", void 0);
//# sourceMappingURL=VenueSearchDemo.dto.js.map